import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { Tooltip } from '@mui/material';
import { IncidentV2SeverityCounts } from '@elementary/common-ui/services/gql/types';
import { severityGrayscaleIconMap } from 'incidents/utils';
import type { Incident } from 'incidents/types';
import type { IncidentListSummary } from '../types';

const SeverityCount = styled(Flex)`
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.common.gray4};
`;

const SEVERITY_ROWS: {
  label: Incident['severity'];
  key: keyof IncidentV2SeverityCounts;
}[] = [
  { label: 'Low', key: 'low' },
  { label: 'Normal', key: 'normal' },
  { label: 'High', key: 'high' },
  { label: 'Critical', key: 'critical' },
];

type Props = {
  bySeverity: IncidentListSummary['bySeverity'] | undefined;
};

const IncidentGroupSeverityMetadata = ({ bySeverity }: Props) => (
  <Flex sx={{ gap: 1.5 }}>
    {SEVERITY_ROWS.filter(({ key }) => bySeverity?.[key]).map(
      ({ label, key }) => (
        <Tooltip key={label} title={`${label} severity`}>
          <SeverityCount>
            {severityGrayscaleIconMap[label]}
            {bySeverity?.[key]}
          </SeverityCount>
        </Tooltip>
      ),
    )}
  </Flex>
);

export default IncidentGroupSeverityMetadata;
